import React from "react";
import { useSettings } from "hooks/useStore";
import Loader from "components/loader";
import DesktopResults from "./desktop";
import MobileResults from "./mobile";

const SearchResult = ({ results, query, loading, popularData, isMobile }) => {
	const { toggleSearch, toggleMenu, isMenuOpen } = useSettings(["toggleSearch", "toggleMenu", "isMenuOpen"]);
	const { popularTerms, popularProducts } = popularData;
	const { products = popularProducts, totalProducts, collection } = query ? results : {};

	const handleClick = () => { isMenuOpen ? toggleMenu() : toggleSearch(); };

	if (query && !results?.products?.length) {
		return (
			<div className="w-full flex justify-center my-auto py-5">
				{loading ? <Loader /> : <span className="text-center">No results found</span>}
			</div>
		);
	}

	return (
		<>
			<div className="search-results">
				{!isMobile ?
					<div className="flex flex-col gap-5">
						<DesktopResults
							results={results}
							query={query}
							products={products}
							collection={collection}
							popularTerms={popularTerms}
							handleClick={handleClick}
						/>
					</div>
					:
					<MobileResults
						products={products}
						query={query}
						handleClick={handleClick}
						totalProducts={totalProducts}
					/>}
			</div>
		</>
	);
};

export default SearchResult;
